/**
 * "Used by people who work at" (was "People use CellCog at"): the ONE source for the customer logo row (HomeLogoRow), on the homepage and
 * /ai-employees (Nitish, Sep 25 2026). Removing a name here removes it from every page.
 *
 * Rulings (Aria's list, Org Drive Marketing/Customer Logos/people_use_cellcog_at_list_sep25.md):
 *  - Heading is a USAGE claim. Never "Trusted by", "Customers" or "Partners" beside these logos.
 *  - A company asks to be removed: delete its line here the SAME DAY and tell Aria (she holds the evidence file).
 *  - Never add a name without Aria's evidence check (Nitish or verified use).
 *  - Logos in their own colours (Nitish, Sep 25 17:53); dark face uses each mark's reversed form.
 * Assets: public/assets/customer-logos/<slug>.webp + <slug>-dark.webp, generated by Maeve's
 * work/customer_logos/colour_logos.py (never hand-edit). w/h = display size in px (desktop).
 */
// Heading changed Sep 29 2026 (Nitish): the evidence is individuals who work at these companies, not company adoption.
export const CUSTOMER_LOGOS_HEADER = 'Used by people who work at';

export const CUSTOMER_LOGOS = [
  // Order = colour-balanced (Nitish, Sep 25 2026 18:08 ET): row 1 = first 19, row 2 = last 19;
  // no two blues side by side, Tencent in row 2, Walmart mid-row. Keep this when adding a name.
  { slug: 'meta', name: "Meta", w: 95, h: 19 },
  { slug: 'apple', name: "Apple", w: 26, h: 32 },
  { slug: 'pwc', name: "PwC", w: 42, h: 32 },
  { slug: 'bloomberg', name: "Bloomberg", w: 95, h: 19 },
  { slug: 'oscar', name: "Oscar Health", w: 90, h: 20 },
  { slug: 'umich', name: "University of Michigan", w: 98, h: 19 },
  { slug: 'ai21', name: "AI21 Labs", w: 91, h: 20 },
  { slug: 'moodys', name: "Moody's", w: 106, h: 18 },
  { slug: 'harrity', name: "Harrity LLP", w: 92, h: 20 },
  { slug: 'signzy', name: "Signzy", w: 74, h: 23 },
  { slug: 'walmart', name: "Walmart", w: 97, h: 18 },
  { slug: 'narrative', name: "Narrative Banking", w: 112, h: 17 },
  { slug: 'athene', name: "Athene Law, LLP", w: 120, h: 16 },
  { slug: 'policybazaar', name: "Policybazaar", w: 88, h: 20 },
  { slug: 'beebee', name: "Beebee AI", w: 85, h: 20 },
  { slug: 'mettle', name: "Mettle Capital", w: 65, h: 26 },
  { slug: 'prestodoctor', name: "PrestoDoctor", w: 63, h: 26 },
  { slug: 'rivet', name: "Rivet", w: 65, h: 25 },
  { slug: 'inventive', name: "Inventive AI", w: 103, h: 18 },
  { slug: 'tencent', name: "Tencent", w: 119, h: 16 },
  { slug: 'ten8labs', name: "Ten8Labs", w: 93, h: 19 },
  { slug: 'oceanstate', name: "Modern Amenities", w: 55, h: 29 },
  { slug: 'sundarbans', name: "Sundarbans Management", w: 88, h: 20 },
  { slug: 'pollen', name: "Pollen Capital", w: 85, h: 20 },
  { slug: 'threatcop', name: "Threatcop", w: 88, h: 20 },
  { slug: 'skydo', name: "Skydo", w: 78, h: 22 },
  { slug: 'imagine', name: "Imagine.art", w: 108, h: 17 },
  { slug: 'gyandhan', name: "GyanDhan", w: 38, h: 32 },
  { slug: 'waterbridge', name: "Waterbridge VC", w: 98, h: 18 },
  { slug: 'truenorth', name: "True North Cleaning", w: 74, h: 23 },
  { slug: 'dianamic', name: "Dianamic", w: 65, h: 25 },
  { slug: 'northstar', name: "Northstar Digital", w: 73, h: 22 },
  { slug: 'abstractunion', name: "Abstract Union", w: 120, h: 14 },
  { slug: 'divyasree', name: "Divyasree", w: 63, h: 26 },
  { slug: 'ivdrasil', name: "Ivdrasil", w: 79, h: 22 },
  { slug: 'wagmi', name: "Wagmi Charters", w: 83, h: 21 },
  { slug: 'geoz', name: "GeoZ", w: 76, h: 23 }, // rebuilt Oct 10 2026 from GeoZ's own SVG (Rohit's request); source in public/assets/customer-logos/src/
  { slug: 'oneclarity', name: "OneClarity", w: 91, h: 19 },
];
